import { Dayjs } from 'dayjs';
import { ScheduleViewType } from 'redux-store/api/profile-preference';
import { IProject } from 'redux-store/api/projects';

export enum PhaseFilterStatusesEnum {
  ALL = 'ALL',
  ALL_BUT_COMPLETED = 'ALL_BUT_COMPLETED',
}

export type ISmallPredecessorItem = {
  endWithLag: string | Date | Dayjs;
  postEndWithLag: string | Date;
  end: string | Date;
  lagDays: number;
};

export interface GanttViewProps {
  project: IProject;
  actualData: IProject;
  isHidden: boolean;
  isOpened: boolean;
  isActualDataLoading: boolean;
  tab: ScheduleViewType;
  onChangeTab: (view: ScheduleViewType) => void;
}

export type TGanttColumns = {
  name: string;
  label: string;
  tree?: boolean;
  width?: number;
  resize?: boolean;
  align?: string;
  max_width?: number;
  min_width?: number;
  template?: (task?: any) => string;
  onrender?: (task?: any, node?: any) => void;
}[];

export type TColorHelperItem = {
  color: string;
  resize: string;
  text: string;
  phaseText: string;
  resizeButton: string;
  light: string;
  itemText: string;
};

export type TRowElementColorHelper = (color: string) => TColorHelperItem;
